import { hasPermissionToEditFile } from '@/app/actions';
import { getMobileEditMode } from '@/app/atoms/mobileStateAtom';
import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';
import { isMobileMode } from '@/app/helpers/isMobile';

/**
 * Whether the current user may change frozen rows/columns via the canvas
 * (dragging the freeze bar or the parked corner handles). Requires file edit
 * permission; on mobile, the edit toggle must also be on since the read-only
 * mobile view is pan/zoom only.
 */
export const canChangeFrozen = (): boolean => {
  if (!hasPermissionToEditFile(gridSettings.getPermissions())) return false;
  if (isMobileMode() && !getMobileEditMode()) return false;
  return true;
};
